import { Box, HStack, Text } from "@chakra-ui/react";
import { Checkbox } from "@chakra-ui/react/checkbox";
import { MdDragIndicator as DragIcon } from "react-icons/md";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CollectionIngredient } from "@/types/api";

interface SortableIngredientItemProps {
  ingredient: CollectionIngredient;
  onToggle: (ingredient: CollectionIngredient, checked: boolean) => void;
}

export default function SortableIngredientItem({
  ingredient,
  onToggle
}: SortableIngredientItemProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: ingredient.id,
    disabled: ingredient.status === 'have'
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      bg={isDragging ? "gray.50" : "white"}
      border="1px"
      borderColor={isDragging ? "green.200" : "gray.200"}
      borderRadius="md"
      p={2}
      shadow={isDragging ? "md" : "none"}
      transition="all 0.2s"
    >
      <HStack gap={2}>
        <Box
          {...attributes}
          {...listeners}
          cursor={ingredient.status === 'have' ? "default" : "grab"}
          opacity={ingredient.status === 'have' ? 0.3 : 0.6}
          _hover={{ opacity: ingredient.status === 'have' ? 0.3 : 1 }}
        >
          <DragIcon size={16} />
        </Box>
        <Checkbox.Root
          checked={ingredient.status === 'have'}
          onCheckedChange={(details) => onToggle(ingredient, !!details.checked)}
        >
          <Checkbox.HiddenInput />
          <Checkbox.Control>
            <Checkbox.Indicator />
          </Checkbox.Control>
        </Checkbox.Root>
        <Text
          flex="1"
          fontSize="sm"
          textDecoration={ingredient.status === 'have' ? "line-through" : "none"}
          opacity={ingredient.status === 'have' ? 0.6 : 1}
        >
          {ingredient.text}
        </Text>
      </HStack>
    </Box>
  );
}
